import { render, staticRenderFns } from "./TotalForged.vue?vue&type=template&id=c6b2a20e&"
import script from "./TotalForged.vue?vue&type=script&lang=ts&"
export * from "./TotalForged.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports